module.exports = __webpack_public_path__ + "de77a722/img/placeholder.888fcd0b.svg";